module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Maasai-Web-640.cd698f03.jpg";